import React from "react";
import { IconButton, Grid } from "@material-ui/core";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

const BackLayout = ({ children, onClick }) => {
	return (
		<Grid style={{ width: "100%", height: "100vh", position: "relative" }}>
			<Grid style={{ position: "absolute", padding: 5, zIndex: 999999 }}>
				<IconButton
					onClick={onClick}
					style={{
						background: "#fff",
						boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.07)"
					}}
				>
					<ExitToAppIcon
						style={{
							color: "#ffc100",
							transform: "rotate(180deg)"
						}}
					/>
				</IconButton>
			</Grid>
			{children}
		</Grid>
	);
};

export default BackLayout;
